import React, { Component } from "react";
import { get, map, filter, each } from "lodash";
import featureFlags from "utils/featureFlags";
import ValidationUtils from "utils/ValidationUtils";
import DeleteConfirmationAlert from "components/DeleteConfirmationAlert";
import { connect } from "react-redux";

import { pmSetSetupDetailsData } from "../../services/documentBuilderSetupPanel";
// Importing the selectedContent Action here
import { pmSetSelectedContent } from "../../services/documentBuilderSetupPanel";

const UI_STRINGS = {
  SELECT_REPO_LABEL: "Select Repo Template",
  SELECT_IMAGE_CATEGORY: "Select Image Category",
  PAGE_NUMBERS_LABEL: "Include Page Numbers",
  OVERVIEW_PAGE_LABEL:
    "Include clickable Table of Contents at the end of your presentation (which will be auto-generated based on the slide content you select)",
  INCLUDE_BREADCRUMB_LABEL: "Include Breadcrumb",
  PRESENTATION_NAME: "Presentation Name*",
  CUSTOMER_NAME: "Customer Name*",
  EMPTY_FIELD_ERROR_MESSAGE: "This field is required.",
  SPECIAL_CHAR_ERROR_MESSAGE: "Please do not enter the special character.",
  WHITE_SPACE_ERROR_MESSAGE: "Please enter a valid input.",
  CONTENT_REPO_CHANGHE_MESSAGE:
    "All your data will be lost. Do you want to continue?"
};

!featureFlags.presentation.showBreadCrumbCheckBox &&
  delete UI_STRINGS[`INCLUDE_BREADCRUMB_LABEL`];

const Container = Main =>
connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class Setup extends Component {
    state = {
      saveLogo: false,
      showSaveProfileCheckbox: true,
      setupDetails: this.props.setupDetailsData,
      showPopUp: false,
      isAnyLogoEdited: false,
      contentSubData: [],
      selectedListDefaultValues: []
    };
    presentationNameRef = React.createRef();

    selectedSubContent = (selected, key) => {
      this.props.setFilterSelectedSetupPage(selected, key);
    };
    handleSelectedListDefaultValuesChange = selectedListDefaultValues => {
      this.setState({
        selectedListDefaultValues
      });
    };

    setSetupDetails = () => {
      let {
        contentRepositoryList: contentRepositoriesList,
        dynamicCoverFieldsList,
        imageCategoryList: imageCategoryListData,
        selectedImageCategoryList,
        handleStateChange,
        buildSetupDetails,
        contentRepo,
        isPresentationNameFocused,
        overviewLimitExceeded,
        getSlideDetailsOnImageCategoriesChange
      } = this.props || {};
      //intiate arrays for drop down fields
      let dynamicCoverFields = [],
        imageCategoryList = {
          key: "imageCategoryList",
          label: UI_STRINGS.SELECT_IMAGE_CATEGORY,
          editable: true,
          type: "multi-select",
          options: [],
          isMulti: true,
          error: "",
          defaultValue: selectedImageCategoryList || {},
          handleChange: (selectedOption, _id) => {
            let selectedAttributeList = selectedImageCategoryList;
            selectedAttributeList[_id] = selectedOption;
            // Handle Selected image category list changes
            handleStateChange({
              key: "selectedImageCategoryList",
              value: selectedAttributeList || [],
              cb: () => {
                getSlideDetailsOnImageCategoriesChange();
              }
            });
          }
        };

      if (
        Array.isArray(dynamicCoverFieldsList) &&
        Object.keys(contentRepo).length
      ) {
        //set dyanamic cover fields
        dynamicCoverFields = dynamicCoverFieldsList.map(elem => {
          let { label, inputType } = elem;
          let key = label.replace(/\s/g, "");
          key = key.charAt(0).toLowerCase() + key.slice(1);

          if (key === "customerName") return {};

          return {
            key,
            type: inputType,
            label: label === "Title" ? "Presentation Title*" : label,
            editable: true,
            value: get(buildSetupDetails[key], "value", ""),
            error: get(buildSetupDetails[key], "error", ""),
            minDate: inputType === "date" && new Date()
          };
        });
      }

      // set image category list dropdown
      const imageCategoryOptionList = [];
      Array.isArray(imageCategoryListData) &&
        imageCategoryListData.forEach(
          ({ _id, title: categoryTitle, attribute }) => {
            let attributeOptionList = [];
            //fetch attributes
            Array.isArray(attribute) &&
              attribute.forEach(({ _id, title: attributeTitle }) => {
                attributeOptionList.push({
                  value: _id,
                  label: attributeTitle,
                  _id,
                  title: attributeTitle
                });
              });

            Array.isArray(attribute) &&
              attribute.length &&
              imageCategoryOptionList.push({
                value: _id,
                label: categoryTitle,
                _id,
                title: categoryTitle,
                options: attributeOptionList
              });
          }
        );

      // imageCategoryList Config
      imageCategoryList.options = imageCategoryOptionList;

      // content repo dropdown config
      const contentRepoDropdown = {
        key: "contentRepo",
        label: UI_STRINGS.SELECT_REPO_LABEL,
        type: "select",
        editable: true,
        value: "",
        error: contentRepo && get(contentRepo, "error", ""),
        showField: get(contentRepositoriesList, `length`) > 1, // do not show field if only one option is present
        handleChange: async selectedOption => {
          const {
            value: _id,
            label: title,
            overviewData,
            maximumSlides,
            aspectRatio,
            metadata
          } = selectedOption || {};
          // Handle Selected Content Repo changes
          await this.handleDropdownChange(null, "contentRepo", {
            _id,
            title,
            overviewData,
            maximumSlides,
            aspectRatio,
            metadata
          });
        },
        options: map(
          contentRepositoriesList,
          ({
            _id: value,
            title: label,
            overviewData,
            maximumSlides,
            aspectRatio,
            metadata
          }) => ({
            value,
            label,
            overviewData,
            maximumSlides,
            aspectRatio,
            metadata
          })
        ),
        defaultValue:
          this.props.contentRepo &&
          Object.keys(this.props.contentRepo).length &&
          !this.props.contentRepo.error
            ? {
                value: get(this.props.contentRepo, "_id"),
                label: get(this.props.contentRepo, "title")
              }
            : null
      };

      const { presentationName, includePageNumber, customerName } =
        buildSetupDetails || {};

      // get the selected content repo on edit flow
      let selectedContentRepo = filter(
        contentRepositoriesList,
        contentRepository => {
          return (
            contentRepository._id ===
            get(this.props, `presentationData.contentRepository`)
          );
        }
      );

      const overViewDataField = [];

      if (
        !overviewLimitExceeded &&
        (get(contentRepo, `overviewData.enable`) ||
          (this.props.match.params.id &&
            get(selectedContentRepo[0], "overviewData.enable")))
      ) {
        overViewDataField.push({
          key: "includeOverview",
          label: UI_STRINGS.OVERVIEW_PAGE_LABEL,
          type: "checkbox",
          editable: true,
          value: get(buildSetupDetails["includeOverview"], `value`, true)
        });
      }

      //check if edit presentation is active
      const checkIfEditIsActiveAndNoDataIsPresent =
        this.props.match.params.id && !!!this.props.presentationData;

      const setupDetails = [
        {
          key: "presentationName",
          label: UI_STRINGS.PRESENTATION_NAME,
          type: "text",
          editable: true,
          value: get(presentationName, "value", ""),
          error: get(presentationName, "error", "")
        },
        {
          key: "customerName",
          label: UI_STRINGS.CUSTOMER_NAME,
          type: "text",
          editable: true,
          value: get(customerName, "value", ""),
          error: get(customerName, "error", "")
        },
        contentRepoDropdown,
        ...(checkIfEditIsActiveAndNoDataIsPresent ? [] : dynamicCoverFields),
        imageCategoryList,
        {
          key: "includePageNumber",
          label: UI_STRINGS.PAGE_NUMBERS_LABEL,
          type: "checkbox",
          editable: true,
          value: get(includePageNumber, "value", true)
        },
        ...overViewDataField,
        {
          key: "breadcrumb",
          label: UI_STRINGS.INCLUDE_BREADCRUMB_LABEL,
          type: "checkbox",
          editable: true,
          value: ""
        }
      ];
      this.props.pmSetSetupDetailsData(setupDetails);
      this.setState({ setupDetails }, () => {
        if (
          this.props.match.params.id &&
          this.presentationNameRef &&
          isPresentationNameFocused
        ) {
          this.presentationNameRef.focus();

          // to avoid setting focus on presentation name after performing any action on screen
          this.props.setFocusValue({
            key: "isPresentationNameFocused",
            value: false
          });
        }
      });

      this.props.pmSetSetupDetailsData(setupDetails);
    };

    handleCheckbox = (e, value, label, type) => {
      const setupDetails = [...this.state.setupDetails];
      setupDetails.forEach(item => {
        if (item.label === e.target.id && item.editable) {
          item.value = value;
          this.props.handleSetupDataChange(item.key, item.value);
        }
      });

      /**
       * On Changing the checkboxes on setup page
       * isEdited field is not getting updated due to which 
       * the changes are not getting patched. The identifier at the moment
       * for the change in any step is isEdited field in the build/container.jsx
       * 
       */
      this.props.handleStateChange({
        key: 'isEdited',
        value: true
      });
      this.setState({ setupDetails });
    };

    componentDidMount() {
      let contentRepoList = this.props.contentRepoList || [];

      // if only option is present call handleDropdownChange without user interaction
      if (get(contentRepoList, `length`) === 1) {
        let _id = contentRepoList && get(contentRepoList[0], `_id`);
        let title = contentRepoList && get(contentRepoList[0], `title`);
        let overviewData =
          contentRepoList && get(contentRepoList[0], `overviewData`);
        let maximumSlides =
          contentRepoList && get(contentRepoList[0], `maximumSlides`);
        this.handleDropdownChange(
          null,
          "contentRepo",
          {
            _id,
            title,
            overviewData,
            maximumSlides,
            aspectRatio: get(contentRepoList[0], `maximumSlides`)
          },
          true
        );
      }

      this.setSetupDetails();
    }

    setRef = refToBeAssigned => {
      this.presentationNameRef = refToBeAssigned;
    };

    componentDidUpdate(prevProps) {
      let { dynamicCoverFieldsList, overviewLimitExceeded } = this.props;

      let {
        dynamicCoverFieldsList: prevDynamicCoverFieldsList,
        overviewLimitExceeded: prevOverviewLimitExceeded
      } = prevProps;

      // flag to check if props has changed
      const checkIfPropsChanged =
        dynamicCoverFieldsList !== prevDynamicCoverFieldsList ||
        this.props.buildSetupDetails !== prevProps.buildSetupDetails ||
        overviewLimitExceeded !== prevOverviewLimitExceeded;

      if (checkIfPropsChanged) {
        this.setSetupDetails();
      }
    }

    onChangeInput = ({ value, label, key, date, flag }) => {
      // console.log( "onChangeInput:", { value, label, key, date, flag } );
      let customerName = filter(this.state.setupDetails, eachDetail => {
        return eachDetail.key === "customerName";
      });

      // only allow logo upload if customer field is filled
      if (label.indexOf("Customer Name") !== -1) {
        this.props.handleStateChange({
          key: "allowLogoUpload",
          value: value.trim().length !== 0 && !!!customerName[0].error
        });
      }

      this.props.handleStateChange({
        key: 'isEdited',
        value: true
      })
      const setupDetails = [...this.state.setupDetails];
      each(setupDetails, item => {
        if (item.label === label && item.editable) {
          item.value = flag ? date : value;
          item.error = this.handleSetupDetailsValidation(
            item.key,
            item.value
          );

          this.props.handleSetupDataChange(key, item.value, item.error);
        }
      });

      this.setState({ setupDetails });
    };

    onSelectChange = e => {
      const setupDetails = [...this.state.setupDetails];
      setupDetails.forEach(item => {
        if (item.label === e.target.id && item.editable) {
          item.value = e.target.value;
        }
      });
      this.setState({ setupDetails });
    };

    isImageCropped = () => {
      this.setState({
        showSaveProfileCheckbox: true
      });
    };

    // array of key names to check for required field validation
    setUpFormKeys = ["presentationName", "customerName", "title"];
    // array of key names to skip existance of whitespace
    excludeField = ["pageNumber", "overview", "presentationDate"];

    /**
     * Setup Validation function
     * @param {String}  key name whose value needs to be checked
     * @param {String}  value which needs to checked
     */

    handleSetupDetailsValidation = (key, value) => {
      if (
        this.setUpFormKeys.indexOf(key) > -1 &&
        ValidationUtils.checkIfEmptyField(value)
      ) {
        return UI_STRINGS.EMPTY_FIELD_ERROR_MESSAGE;
      } else if (
        this.excludeField.indexOf(key) === -1 &&
        ValidationUtils.checkIfWhiteSpace(value)
      ) {
        return UI_STRINGS.WHITE_SPACE_ERROR_MESSAGE;
      } else if (ValidationUtils.checkIfspecialChar(value)) {
        return UI_STRINGS.SPECIAL_CHAR_ERROR_MESSAGE;
      }
    };

    handleDropdownChange = (e, key, selectedOption, flag) => {
      let {
        contentRepo,
        selectSlides,
        handleStateChange,
        clearSavedData
      } = this.props;
      if (selectedOption && selectedOption.metadata !== undefined)
        selectedOption.metadata = map(selectedOption.metadata, data => {
          data.value = "";
          return data;
        });
      // create better-named synonyms for new code to use
      const newContentRepo = selectedOption;
      const newContentRepoId = newContentRepo._id;
      
      // fetchThemeList is available due to blind-spread of
      // parent component. It's a method on 
      // src/tools/presentation/pages/build/container.jsx

      const cb = () => {
        this.props.onContentRepoDropdownChanged(selectedOption._id, true);
      };

      let value = {
        _id: selectedOption._id || null,
        title: selectedOption.title || "",
        overviewData: selectedOption.overviewData || {},
        maximumSlides: selectedOption.maximumSlides || 60,
        aspectRatio: selectedOption.aspectRatio
      };

      /**
       * For a freshly created document the contentRepo should be set 
       * simply by selecting contentRepo from list...
       * This block of code will not work if edit mode it on.
       * The edit flow will follow a path of confirmation and then changing 
       * the values. 
       */
      if(!this.props.match.params.id){
        this.props.setSelectedContent(newContentRepo);
        this.props.pmSetSelectedContent(newContentRepo);
      }
      // get content repo id from contentRepo prop
      let id = contentRepo && get(contentRepo, "_id", null);

      // condition stop api calling if same content repo selected again
      if (id && id !== selectedOption._id) {
        // condition provide confirmation popup
        if (!this.showConfirmation() || selectSlides.length || this.props.isEdited) {
          DeleteConfirmationAlert({
            message: UI_STRINGS.CONTENT_REPO_CHANGHE_MESSAGE,
            onYesClick: () => {
              // set new content repo id on state
              handleStateChange({ key, value, cb });
              // clear existing data on content repo change
              clearSavedData(selectedOption._id);

              this.props.setSelectedContent(newContentRepo);
              this.props.pmSetSelectedContent(newContentRepo);

              // Fetching the themes if the user Clicks yes
              // Look at the fetchThemeList function in the build/container.jsx
              // implementaion of how it sets the theme and cover with default values
              this.props.fetchThemeList(newContentRepoId);
            }
          });
        } else {
          // set new content repo id on state
          handleStateChange({ key, value, cb });
        }
      } else if (!id) {
        // set new content repo id on state
        handleStateChange({ key, value, cb }, flag);
      }
    };

    // array to skip these field while checking existence of value
    skipTheseFields = [
      "presentationDate",
      "presentationName",
      "includeOverview",
      "includePageNumber",
      "customerName"
    ];

    /**
     * function which checks for existence of data in setupdetails
     * @returns {Boolean} if data exist in setupbuild details
     */

    showConfirmation = () => {
      let buildSetupDetails = this.props.buildSetupDetails;
      let flag = true;
      if (buildSetupDetails) {
        for (let item in buildSetupDetails) {
          if (
            this.skipTheseFields.indexOf(item) === -1 &&
            buildSetupDetails[item].value
          ) {
            flag = false;
            break;
          }
        }
      }
      return flag;
    };

    render() {
      // console.log( "Container: ", { setupDetailsdata: this.props.setupDetailsData });
      // console.log( "Container: ", { contentRepositorySelected: this.props.contentRepositorySelected });
      return (
        <Main
          setRef={this.setRef}
          setupDetailsData={this.props.setupDetailsData}
          onChangeInput={this.onChangeInput}
          handleCheckbox={this.handleCheckbox}
          isSubContentRepo={this.props.isSubContentRepo}
          selectedSubContent={this.props.selectedSubContent}
          handleSelectedContent={this.props.handleSelectedContent}
          contentRepositorySelected={this.props.contentRepositorySelected}
          nextStepHandler={this.props.nextStepHandler}
          isEdited={this.props.isEdited}
          onSave = {this.props.onSave}
        />
      );
    }
  }
);

const mapStateToProps = state => {
  const { PM_SET_SELECTED_CONTENT, PM_SET_SETUP_DETAILS, SUCCESS_SETUP_CONTENTREPO: { contentRepoList } } = state;
  return {
    contentRepositorySelected: PM_SET_SELECTED_CONTENT,
    setupDetailsData: PM_SET_SETUP_DETAILS,    
    contentRepositoryList: contentRepoList
  };
};

const mapDispatchToProps = {
  pmSetSelectedContent,
  pmSetSetupDetailsData
};

export default Container;
